import { useQuery } from "@tanstack/react-query"
import { SankeyData, SankeyDataWithSplit } from '../../backend/types/moneyflow.ts'

export const useGetSankeyData = (id?: string, isPublic?: boolean) => useQuery<SankeyDataWithSplit>({
    queryKey: [!isPublic ? `sankey-data/${id}` : `/public/sankey-data/${id}`],
    enabled: !!id
})

export const useGetAllSankeyDataMeta = (moneyflowId?: string) => useQuery<Omit<SankeyData, 'Edges' | 'Entities'>[]>({
    queryKey: [`sankey-data/meta/${moneyflowId}`],
    enabled: !!moneyflowId
})
